import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconThunderstorms: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M62.1556 72.0556L67.7556 60.9111H61.6333L56 76.5H62.8889L58.7778 87.5778L58.8444 87.5L58.8 87.5778H60.2111L71.2222 72.0556H62.1556Z"
        fill="#F5BD00"
      />
      <path
        d="M42.5197 61L32.8359 87.9304H37.6161L47.2886 61H42.5197Z"
        fill="#87D6F8"
      />
      <path
        d="M52.2931 61L42.6094 87.9304H47.3895L57.0733 61H52.2931Z"
        fill="#87D6F8"
      />
      <path
        d="M32.8924 61L28 74.4652H32.7689L37.6725 61H32.8924Z"
        fill="#87D6F8"
      />
      <path
        d="M74.9556 36.6889H69.8778V31.7556C69.8778 20.8444 60.7778 12 49.5556 12C40.1 12 32.2222 18.3111 29.9556 26.8111H29.2333C20.8222 26.8111 14 33.4444 14 41.6222C14 49.8 20.8222 56.4333 29.2333 56.4333H34.3111H64.7889H74.9445C80.5556 56.4333 85.1 52.0111 85.1 46.5556C85.1 41.1 80.5667 36.6889 74.9556 36.6889Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconThunderstorms
